import {
  SET_VISIT_DATE,
  SET_VISIT_COMMENTS,
  SET_VISIT_REMINDER_EMAIL,
  SET_VEHICLE_MAKE,
  SET_VEHICLE_MODEL,
  SET_VEHICLE_COLOR
} from '../actionTypes/visit';


export function setDate(value) {
  return {
    type: SET_VISIT_DATE,
    value
  };
}


export function setComments(value) {
  return {
    type: SET_VISIT_COMMENTS,
    value
  };
}


export function setVehicleMake(value) {
  return {
    type: SET_VEHICLE_MAKE,
    value
  };
}


export function setVehicleModel(value) {
  return {
    type: SET_VEHICLE_MODEL,
    value
  };
}


export function setVehicleColor(value) {
  return {
    type: SET_VEHICLE_COLOR,
    value
  };
}


export function setVisitReminderEmail(value) {
  return {
    type: SET_VISIT_REMINDER_EMAIL,
    value
  };
}


// WEBPACK FOOTER //
// ./src/actions/visit.js